import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const showArray = /* #__PURE__ */ (() => (
  {show: Data$dShow.showArrayImpl(Data$dShow.showArrayImpl(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.showFreeProduct.show))}
))();
const OutputCartDataIsSymbol = {reflectSymbol: () => "OutputCartData"};
const InputCartDataIsSymbol = {reflectSymbol: () => "InputCartData"};
const eqArray = /* #__PURE__ */ (() => ({eq: Data$dEq.eqArrayImpl(Data$dEq.eqArrayImpl(Restaumatic$dPromotionsEngine$dPromotions$dTypes$dPromotion.eqFreeProduct.eq))}))();
const sum = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const OutputCartData = x => x;
const InputCartData = x => x;
const newtypeOutputCartData = {Coercible0: () => {}};
const promotionalItems = x => x.promotionalItems;
const setAllFreeProducts = allFreeProductsInit => outputCartData => ({...outputCartData, allFreeProducts: allFreeProductsInit});
const subtotal = x => x.subtotal;
const total = x => x.total;
const subFromTotal = money => outputCartData => ({...outputCartData, total: max(0)(outputCartData.total - money | 0)});
const newtypeInputCartData = {Coercible0: () => {}};
const productItems = x => x.productItems;
const mkOutputCartData = productItemsInit => promotionalItemsInit => subtotalInit => totalInit => allFreeProductsInit => (
  {productItems: productItemsInit, promotionalItems: promotionalItemsInit, subtotal: subtotalInit, total: totalInit, allFreeProducts: allFreeProductsInit}
);
const mkInputCartData = productsArr => (
  {
    productItems: Data$dArray.concat(productsArr),
    orderType: Restaumatic$dPromotionsEngine$dCart$dCartParams.Delivery,
    deliveryZone: 1,
    requestedTime: Restaumatic$dPromotionsEngine$dCart$dCartParams.Asap,
    assignmentMode: Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign
  }
);
const genericOutputCartData = {to: x => x, from: x => x};
const showOutputCartData = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.showPromotionalItem(dictShow).show);
        const $1 = Data$dShow.showArrayImpl(Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItem(dictShow).show);
        return {
          genericShowArgs: v => [
            "{ allFreeProducts: " + showArray.show(v.allFreeProducts) + ", productItems: " + $1(v.productItems) + ", promotionalItems: " + $0(v.promotionalItems) + ", subtotal: " + Data$dMoney$dRounded.toString(v.subtotal) + ", total: " + Data$dMoney$dRounded.toString(v.total) + " " + "}"
          ]
        };
      })())(OutputCartDataIsSymbol);
      return x => $0["genericShow'"](x);
    })()
  }
);
const genericInputCartData = {to: x => x, from: x => x};
const showInputCartData = dictShow => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
        const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotionsEngine$dCart$dProductItem.showProductItem(dictShow).show);
        return {
          genericShowArgs: v => [
            "{ assignmentMode: " + Restaumatic$dPromotionsEngine$dCart$dCartParams.showAssignmentMode.show(v.assignmentMode) + ", deliveryZone: " + Restaumatic$dPromotionsEngine$dCart$dCartParams.showDeliveryZone.show(v.deliveryZone) + ", orderType: " + Restaumatic$dPromotionsEngine$dCart$dCartParams.showOrderType.show(v.orderType) + ", productItems: " + $0(v.productItems) + ", requestedTime: " + Restaumatic$dPromotionsEngine$dCart$dCartParams.showRequestedTime.show(v.requestedTime) + " " + "}"
          ]
        };
      })())(InputCartDataIsSymbol);
      return x => $0["genericShow'"](x);
    })()
  }
);
const findProduct = dictEq => inputCartData => itemKey => Data$dFoldable.find(Data$dFoldable.foldableArray)(productItem => dictEq.eq(itemKey.product)(productItem.productItemKey.product) && itemKey.productSeq === productItem.productItemKey.productSeq)(inputCartData.productItems);
const eqOutputCartData = dictEq => (
  {
    eq: (() => {
      const $0 = Data$dEq.eqArrayImpl(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.eqPromotionalItem(dictEq).eq);
      const $1 = Data$dEq.eqArrayImpl(Restaumatic$dPromotionsEngine$dCart$dProductItem.eqProductItem(dictEq).eq);
      return x => y => eqArray.eq(x.allFreeProducts)(y.allFreeProducts) && $1(x.productItems)(y.productItems) && $0(x.promotionalItems)(y.promotionalItems) && x.subtotal === y.subtotal && x.total === y.total;
    })()
  }
);
const eqInputCartData = dictEq => (
  {
    eq: (() => {
      const $0 = Data$dEq.eqArrayImpl(Restaumatic$dPromotionsEngine$dCart$dProductItem.eqProductItem(dictEq).eq);
      return x => y => (() => {
        if (x.assignmentMode.tag === "AutoAssign") {
          if (y.assignmentMode.tag === "AutoAssign") { return true; }
          if (y.assignmentMode.tag === "ManualAssign") { return false; }
          $runtime.fail();
        }
        if (x.assignmentMode.tag === "ManualAssign") {
          if (y.assignmentMode.tag === "AutoAssign") { return false; }
          if (y.assignmentMode.tag === "ManualAssign") { return true; }
          $runtime.fail();
        }
        $runtime.fail();
      })() && x.deliveryZone === y.deliveryZone && Restaumatic$dPromotionsEngine$dCart$dCartParams.eqOrderType.eq(x.orderType)(y.orderType) && $0(x.productItems)(y.productItems) && Restaumatic$dPromotionsEngine$dCart$dCartParams.eqRequestedTime.eq(x.requestedTime)(y.requestedTime);
    })()
  }
);
const calcSubtotal = items => sum(Data$dFunctor.arrayMap(x => x.productPrice)(items));
const calcSubtotalCart = outputCartData => sum(Data$dFunctor.arrayMap(x => x.productPrice)(outputCartData.productItems));
const calcSubtotalInputCartData = inputCartData => sum(Data$dFunctor.arrayMap(x => x.productPrice)(inputCartData.productItems));
const mkDefaultOutputCartData = inputCartData => promotionalItemsInit => {
  const subtotalInit = sum(Data$dFunctor.arrayMap(x => x.productPrice)(inputCartData.productItems));
  return {productItems: inputCartData.productItems, promotionalItems: promotionalItemsInit, subtotal: subtotalInit, total: subtotalInit, allFreeProducts: []};
};
const assignmentMode = x => x.assignmentMode;
const allFreeProducts = x => x.allFreeProducts;
const addToTotal = money => outputCartData => ({...outputCartData, total: max(0)(outputCartData.total + money | 0)});
const addFreeProducts = freeProducts => outputCartData => ({...outputCartData, allFreeProducts: Data$dSemigroup.concatArray([freeProducts])(outputCartData.allFreeProducts)});
export {
  InputCartData,
  InputCartDataIsSymbol,
  OutputCartData,
  OutputCartDataIsSymbol,
  addFreeProducts,
  addToTotal,
  allFreeProducts,
  assignmentMode,
  calcSubtotal,
  calcSubtotalCart,
  calcSubtotalInputCartData,
  eqArray,
  eqInputCartData,
  eqOutputCartData,
  findProduct,
  genericInputCartData,
  genericOutputCartData,
  max,
  mkDefaultOutputCartData,
  mkInputCartData,
  mkOutputCartData,
  newtypeInputCartData,
  newtypeOutputCartData,
  productItems,
  promotionalItems,
  setAllFreeProducts,
  showArray,
  showInputCartData,
  showOutputCartData,
  subFromTotal,
  subtotal,
  sum,
  total
};
